import React, { useEffect, useState } from 'react'
import AdsNavbar from '../AdsNavbar'
import Loader from '../../../components/Loader'
import Calling from '../../../api/Calling';
import { toast } from 'react-toastify';
import NotFound from '../../../components/ul/NotFound';
import TopNavbar from '../TopNavbar';

const RewardAds = () => {
    const [loader, setLoader] = useState(false);
    const [nativeAds, setNativeAds] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [showAddForm, setShowAddForm] = useState(false);
    const [newAd, setNewAd] = useState({ a_name: '', a_id: '', a_description: '' });
    const [searchTerm, setSearchTerm] = useState('');

    const fetchData = async () => {
        setLoader(true);
        try {
            const resp = await Calling.getRewardAds();
            if (resp?.status) {
                setNativeAds(resp?.data);
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    }

    const filteredAds = nativeAds.filter(ad =>
        ad.a_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ad.a_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ad.a_description.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleEdit = (id) => {
        setEditingId(id);
    }

    const handleSave = async (id) => {
        const adToUpdate = nativeAds.find(ad => ad._id === id);
        setLoader(true);

        try {
            const resp = await Calling.updateRewardAds(id, {
                a_id: adToUpdate.a_id,
                a_description: adToUpdate?.a_description
            });
            if (resp?.status) {
                toast.success(resp?.message);
                fetchData();
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
            setEditingId(null);
        }
    }

    const handleInputChange = (id, field, value) => {
        setNativeAds(nativeAds.map(item =>
            item._id === id ? { ...item, [field]: value } : item
        ));
    }

    const handleAddSubmit = async () => {
        if (newAd.a_name.trim() === '' || newAd.a_id.trim() === '' || newAd.a_description.trim() === '') {
            toast.error('Please fill all the fields');
            return;
        }

        setLoader(true);
        try {
            const body = {
                a_name: newAd.a_name.replace(/ /g, ''),
                a_id: newAd.a_id.replace(/ /g, ''),
                a_description: newAd.a_description
            }
            const resp = await Calling.addRewardAds(body);
            if (resp?.status) {
                toast.success(resp?.message);
                setNewAd({ a_name: '', a_id: '', a_description: '' });
                setShowAddForm(false);
                fetchData();
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    }

    return (
        <>
            {loader ? (
                <Loader loader={loader} />
            ) : (
                <div className="px-3 sm:ml-[4.4rem] w-full md:mt-20 mt-16 overflow-hidden">
                    <div className="w-full mt-4 mb-2">
                        <h1 className="text-xl sm:text-2xl font-bold">Ad Management</h1>
                    </div>
                    <div className='bg-main-white rounded-xl shadow-sm'>
                        <TopNavbar selectState={'android'} />
                        <hr className='mt-2 bg-main-border border-[1px]' />
                        <AdsNavbar selectState={'rewardads'} />
                        <hr className='mt-2 bg-main-border border-[1px]' />

                        <div className='px-4 sm:px-6 pt-4 sm:pt-6'>
                            <div className='flex flex-col sm:flex-row justify-between items-center mb-4 sm:mb-5'>
                                <h1 className='text-lg sm:text-2xl font-bold text-main-font mb-2 sm:mb-0'>Reward Ads</h1>
                                <button
                                    onClick={() => setShowAddForm(!showAddForm)}
                                    className='px-3 py-2 text-sm sm:text-md text-main-white bg-green-600 rounded-3xl hover:bg-green-700'
                                >
                                    + Add Reward Ads
                                </button>
                            </div>
                            <hr className='border-main-border' />

                            {showAddForm && (
                                <div className="mt-4 sm:mt-6 p-3 sm:p-4 rounded-lg space-y-4 bg-main-bg">
                                    <div className='grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4'>
                                        <div className='flex flex-col sm:flex-row items-center'>
                                            <label className='w-full sm:w-1/4 text-sm sm:text-base text-main-font font-medium mb-2 sm:mb-0'>Ad Name:</label>
                                            <input
                                                type="text"
                                                placeholder="Ad Name"
                                                value={newAd.a_name}
                                                onChange={(e) => setNewAd({ ...newAd, a_name: e.target.value })}
                                                className='w-full p-2 border border-main-border rounded text-sm focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                            />
                                        </div>
                                        <div className='flex flex-col sm:flex-row items-center'>
                                            <label className='w-full sm:w-1/4 text-sm sm:text-base text-main-font font-medium mb-2 sm:mb-0'>Ad ID:</label>
                                            <input
                                                type="text"
                                                placeholder="Ad ID"
                                                value={newAd.a_id}
                                                onChange={(e) => setNewAd({ ...newAd, a_id: e.target.value })}
                                                className='w-full p-2 border border-main-border rounded text-sm focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                            />
                                        </div>
                                    </div>

                                    <div className='grid grid-cols-1 gap-2'>
                                        <label className='text-sm sm:text-base text-main-font font-medium'>Description:</label>
                                        <textarea
                                            type="text"
                                            placeholder="Ad Description"
                                            value={newAd?.a_description}
                                            onChange={(e) => setNewAd({ ...newAd, a_description: e.target.value })}
                                            className='w-full p-2 border border-main-border rounded text-sm focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                        />
                                    </div>

                                    <div className='flex justify-start'>
                                        <div className="flex gap-3 sm:gap-4 py-2">
                                            <button
                                                onClick={handleAddSubmit}
                                                className="px-3 py-1 text-sm sm:text-md text-main-white bg-main-blue rounded hover:bg-main-blue/80 transition"
                                            >
                                                Submit
                                            </button>
                                            <button
                                                onClick={() => setShowAddForm(false)}
                                                className="px-3 py-1 text-sm sm:text-md text-main-delete border border-main-delete bg-main-white rounded hover:bg-main-delete/10 transition"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="overflow-x-auto py-4 sm:py-6">
                            {/* Search Bar */}
                            <div className="mb-4 sm:mb-6 px-4 sm:px-6">
                                <input
                                    type="text"
                                    placeholder="Search Ads..."
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    className="p-2 border rounded-lg w-full text-sm"
                                />
                            </div>

                            <div className='overflow-x-auto'>
                                <table className='w-full min-w-[800px]'>
                                    <thead className='bg-main-th text-main-font uppercase'>
                                        <tr>
                                            <th className="text-left px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium rounded-tl-lg">No</th>
                                            <th className="text-left px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium">Ad Name</th>
                                            <th className="text-left px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium">Ad ID</th>
                                            <th className="text-left px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium">Ad Description</th>
                                            <th className="text-center px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium rounded-tr-lg">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredAds.length > 0 ?
                                            filteredAds?.map((item, index) => (
                                                <tr key={index} className="hover:bg-main-thHover">
                                                    <td className="px-3 sm:px-4 py-2 text-xs sm:text-sm text-main-font">{index + 1}</td>
                                                    <td className="px-3 sm:px-4 py-2 text-xs sm:text-sm text-main-font">{item.a_name}</td>
                                                    <td className="px-3 sm:px-4 py-2 text-xs sm:text-sm text-main-font">
                                                        {editingId === item._id ? (
                                                            <input
                                                                type="text"
                                                                value={item.a_id}
                                                                onChange={(e) => handleInputChange(item._id, 'a_id', e.target.value)}
                                                                className="p-2 w-full border border-main-border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-xs sm:text-sm"
                                                            />
                                                        ) : (
                                                            <span className="text-xs sm:text-sm text-main-font break-all">{item.a_id}</span>
                                                        )}
                                                    </td>
                                                    <td className="px-3 sm:px-4 py-2 text-xs sm:text-sm">
                                                        {editingId === item._id ? (
                                                            <textarea
                                                                type="text"
                                                                value={item.a_description}
                                                                onChange={(e) => handleInputChange(item._id, 'a_description', e.target.value)}
                                                                className="p-2 w-full border border-main-border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-xs sm:text-sm"
                                                            />
                                                        ) : (
                                                            <span className="text-xs sm:text-sm text-main-font break-all">{item.a_description}</span>
                                                        )}
                                                    </td>
                                                    <td className="text-center px-3 sm:px-4 py-2">
                                                        <div className="flex justify-center gap-2">
                                                            <button
                                                                onClick={() => editingId === item._id ? handleSave(item._id) : handleEdit(item._id)}
                                                                className={`px-3 sm:px-4 py-1 text-xs sm:text-sm text-main-white rounded transition-colors ${editingId === item._id
                                                                    ? 'bg-green-500 hover:bg-green-600 active:bg-green-700'
                                                                    : 'bg-blue-500 hover:bg-blue-600 active:bg-blue-700'
                                                                    }`}
                                                            >
                                                                {editingId === item._id ? 'Save' : 'Edit'}
                                                            </button>
                                                            {editingId === item._id && (
                                                                <button
                                                                    onClick={() => setEditingId(null)}
                                                                    className="px-3 sm:px-4 py-1 text-xs sm:text-sm font-medium text-main-white bg-red-500 hover:bg-red-600 active:bg-red-700 rounded transition-colors"
                                                                >
                                                                    Cancel
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                            :
                                            <tr><td className='text-center' colSpan={5}><NotFound /></td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default RewardAds